"use client";

import { useMemo } from "react";
import { analytics } from "@/lib/analytics/analytics.facade";
import type { AnalyticsTraits, EventProperties } from "@/lib/analytics/analytics.types";

export interface UseAxReturn {
  track: (name: string, properties?: EventProperties) => void;
  pageView: (path: string) => void;
  identify: (traits: AnalyticsTraits) => void;
  reset: () => void;
}

/**
 * React hook for client-side analytics (HubSpot + Mixpanel via the analytics facade).
 *
 * @example
 * const { track } = useAx();
 * track("api_key_created", { source: "settings" });
 */
export const useAx = (): UseAxReturn => {
  return useMemo(
    () => ({
      track: analytics.track,
      pageView: analytics.pageView,
      identify: analytics.identify,
      reset: analytics.reset,
    }),
    [],
  );
};
